import { createQuery } from "react-query-kit";

import type {
  IAppointmentTableEndpoint,
  IAppointmentTableEndpointParams,
} from "@api/appointment";
import type {
  IApiResponse,
  IAxiosFn,
  IPaginationParams,
  ISearchParams,
  IWithFilters,
  IWithPagination,
  IWithStats,
} from "@/api";
import { axiosClient, AxiosError } from "@/api";

const key = "appointment-table";

type IResponse = IApiResponse<
  IWithFilters<IWithStats<IWithPagination<IAppointmentTableEndpoint>>>
>;
export type IVariables = IPaginationParams &
  ISearchParams &
  IAppointmentTableEndpointParams;

// TODO FIX URL
export const getAppointmentTable: IAxiosFn<IVariables, IResponse> = async (
  params,
  signal,
) => {
  const { data } = await axiosClient.get("/appointments", {
    params,
    signal,
  });

  return data;
};

export const useAppointmentTable = createQuery<
  IResponse,
  IVariables,
  AxiosError
>({
  primaryKey: key,
  queryFn: ({ queryKey: [_primaryKey, variables], signal }) =>
    getAppointmentTable(variables, signal),
  retry(_failureCount, error) {
    return error.code !== AxiosError.ERR_BAD_REQUEST;
  },
  keepPreviousData: true,
});
